export const ROUTE_TYPES = {
    INDEX: 'index',
    ALL_MODELS: 'all_models',
    NEW_ENTRY: 'new_entry',
    VIEW_ENRY: 'view_enry',
    EDIT_ENTRY: 'edit_entry',
    SUBVIEW: 'subview',
    CHANGE_PAGE: 'change_page',
    CHANGE_APP_PAGE: 'change_app_page',
};

const routes = {
    '/': { type: ROUTE_TYPES.INDEX, },

    // test pages
    '/test': { type: ROUTE_TYPES.CHANGE_PAGE, page: 'test' },
    '/testchild': { type: ROUTE_TYPES.CHANGE_PAGE, page: 'testchild' },
    '/testgrid': { type: ROUTE_TYPES.CHANGE_PAGE, page: 'testgrid' },
    '/testtypography': { type: ROUTE_TYPES.CHANGE_PAGE, page: 'testtypography' },

    // '/map': { type: ROUTE_TYPES.CHANGE_APP_PAGE, appPage: 'map' },
    // '/dashboard': { type: ROUTE_TYPES.CHANGE_APP_PAGE, appPage: 'dashboard' },
    // '/help(/:category)': { type: ROUTE_TYPES.CHANGE_APP_PAGE, appPage: 'help' },
    // '/book': { type: ROUTE_TYPES.CHANGE_APP_PAGE, appPage: 'book' },
    '/not_authorized': { type: ROUTE_TYPES.CHANGE_APP_PAGE, appPage: 'notAuthorized' },

    '/forgot_password': { type: ROUTE_TYPES.CHANGE_APP_PAGE, appPage: 'forgot_password' },
    '/reset_password': { type: ROUTE_TYPES.CHANGE_APP_PAGE, appPage: 'reset_password'},

    '/:model': {
        type: ROUTE_TYPES.ALL_MODELS,
        '/:id': { type: ROUTE_TYPES.VIEW_ENRY, },
        '/views/:viewId': {type: ROUTE_TYPES.ALL_MODELS,},
        '/:id/*': { type: ROUTE_TYPES.SUBVIEW, },
        '/:id/edit': { type: ROUTE_TYPES.EDIT_ENTRY, },
        '/:id/views/:viewId': { type: ROUTE_TYPES.VIEW_ENRY, }
    },
};

export default routes;